import Close from "../../assets/svgs/Close.svg";

const Modal = ({
  show,
  title,
  desc,
  onClose,
  children,
  width = "520px",
  height,
  disableContentWrapperStyle = false,
  closeOnOutsideClick = false,
}) => {
  return (
    <div
      className={`${show ? "flex" : "hidden"} fixed inset-0 bg-gray-900 bg-opacity-50 z-[99999]`}
      id="modal"
      style={{ justifyContent: "center", alignItems: "center" }}
      onClick={(e) => {
        if (closeOnOutsideClick && e.target.id === "modal" && onClose) {
          onClose();
        }
      }}
    >
      <div
        className="relative mx-auto py-5 pl-5 border shadow-lg rounded-2xl bg-white"
        style={{ width: width, height: height }}
      >
        <div className="flex justify-between pr-5">
          <p className="head-2 dark-H capitalize">{title}</p>
          <img role="button" src={Close} alt="close" onClick={onClose} />
        </div>
        {desc && <p className="dark-M body-N mt-2">{desc}</p>}
        <div className={disableContentWrapperStyle ? "" : "mt-[15px] pr-5 overflow-y-auto max-h-[70vh]"}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;